<template>
	<div class="k-page-content" v-loading="loading">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane :label="infoData.title_info.title" name="first" v-if="infoData.title_info.title">
				<div class="k-page-common">
					<div class="k-common-header" style="padding: 12px;">
						<div class="proDeTitle">
							<div>
								<span class="t1">{{ infoData.title_info.title }}：</span>
								<span class="t2">{{ infoData.title_info.code }}</span>
								<span class="t3">{{ infoData.title_info.status }}</span>
							</div>
							<div class="back" @click="goBack()">
								<i class="el-icon-back"></i>返回上一页
							</div>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="whiteBox" style="padding-bottom: 0;">
								<div class="projectDetailTop">
									<div class="tyTitle">
										<p>基本信息</p>
									</div>
									<layoutStep v-if="infoData.title_info.title" :stepinfo="infoData"></layoutStep>
									<div class="detailBox">
										<ul>
											<li v-for="(item, index) in infoData.info" :key="index"
												v-if="item.type == 'text' || item.type == 'text_url'">
												<template v-if="item.type == 'text'">
													<span class="title">{{ item.label }}</span>
													<div class="con" :title="item.value">{{ item.value }}</div>
												</template>
												<template v-if="item.type == 'text_url'">
													<span class="title">{{ item.label }}</span>
													<div class="con" :title="item.value">
														<span @click="routerGo(item.url_params)"
															style="color:#409EFF;cursor: pointer;">{{ item.value }}</span>
													</div>
												</template>

											</li>
											<li v-for="(item, index) in infoData.info" :key="index" v-if="item.type == 'img'">
												<span class="title">{{ item.label }}</span>
												<div class="con">
													<template v-if="item.value && item.value.length > 0">
														<span v-for="(itema, indexa) in item.value" :key="indexa">
															<el-link type="primary" :href="itema" target="_blank"
																rel="noopener noreferrer">附件{{ indexa + 1 }}</el-link>{{ indexa == item.value.length - 1 ? '' :
															'、'}}
														</span>
													</template>
													<span v-else>--</span>
												</div>
											</li>
										</ul>
									</div>
									<div style="padding-bottom: 20px;" v-for="(item, index) in infoData.info" :key="index"
										v-if="item.type == 'table'">
										<div class="tyTitle">
											<p>{{ item.label }}</p>
										</div>
										<el-table :data="item.value.data" style="width: 100%" row-key="id" border stripe ref="tablecontract"
											v-loading="loading" highlight-current-row>
											<template v-for="(itemc, indexc) in item.value.field">
												<!--修改成本详情-->
												<el-table-column v-if="itemc.prop == 'duibi'" :prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<el-popover placement="right" width="600" v-if="scope.row.duibi.list.length > 0"
															trigger="hover">
															<div>
																<el-table :data="scope.row.duibi.list" style="width: 100%;" border stripe height="400"
																	highlight-current-row>
																	<el-table-column min-width="150" property="create_time"
																		label="修改时间"></el-table-column>
																	<el-table-column width="80" property="old_quotation_price_txt"
																		label="原报价"></el-table-column>
																	<el-table-column width="80" property="new_quotation_price_txt"
																		label="现报价"></el-table-column>
																	<el-table-column width="80" property="old_strike_price_txt"
																		label="原执行价"></el-table-column>
																	<el-table-column width="80" property="new_strike_price_txt"
																		label="现执行价"></el-table-column>
																	<el-table-column width="80" property="old_point_price_txt"
																		label="原返点"></el-table-column>
																	<el-table-column width="80" property="new_point_price_txt"
																		label="现返点"></el-table-column>
																</el-table>
															</div>
															<el-link type="primary" slot="reference" style="font-size: 14px;"
																:underline="false">{{ scope.row.duibi.title }}</el-link>
														</el-popover>
														<span v-else style="color: #409EFF; font-weight: bold;">
															{{ scope.row.duibi.title }}
														</span>
													</template>
												</el-table-column>
												<el-table-column v-else-if="itemc.prop == 'invoice_list_info'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-html="scope.row.invoice_list_info"></div>
													</template>
												</el-table-column>
												<el-table-column v-else-if="itemc.prop == 'pay_list_info'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-html="scope.row.pay_list_info"></div>
													</template>
												</el-table-column>
												<!--供应商详情 发布方式-->
												<el-table-column v-else-if="itemc.prop == 'price_names'" :width='itemc.width' :prop="itemc.prop"
													:label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.price_names.length > 0">
															<p v-for="(itemd, indexd) in scope.row.price_names">{{ itemd }}</p>
														</div>
													</template>
												</el-table-column>
												<!--供应商详情 发布方式-价格-->
												<el-table-column v-else-if="itemc.prop == 'price_list'" width="300" align="center"
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div class="price-box-inner">
															<div v-for="(itemf, indexf) in scope.row.price_list" :key="indexf">
																<div class="price-cell" v-if="itemf.price3">
																	<div class="p4" v-if="itemf.price3.length > 1">
																		<span>{{ itemf.price3[0] }}</span>
																		<span><i>折</i>{{ itemf.price3[1] }}</span>
																	</div>
																	<div class="p4" v-else>
																		<span></span>
																		<span>{{ itemf.price3[0] }}</span>
																	</div>
																</div>
																<div class="price-cell" v-if="itemf.price1 && itemf.price2">
																	<div class="p2" v-if="itemf.price1.length > 1">
																		<span>{{ itemf.price1[0] }}</span>
																		<span><i>折</i>{{ itemf.price1[1] }}</span>
																	</div>
																	<div class="p2" v-else>
																		<span></span>
																		<span>{{ itemf.price1[0] }}</span>
																	</div>
																	<div class="p3" v-if="itemf.price2.length > 1">
																		<span>{{ itemf.price2[0] }}</span>
																		<span><i>折</i>{{ itemf.price2[1] }}</span>
																	</div>
																	<div class="p3" v-else>
																		<span></span>
																		<span>{{ itemf.price2[0] }}</span>
																	</div>
																</div>
																<div class="price-cell" v-if="itemf.price1 && !itemf.price2">
																	<div class="p5" v-if="itemf.price1.length > 1">
																		<span>{{ itemf.price1[0] }}</span>
																		<span><i>折</i>{{ itemf.price1[1] }}</span>
																	</div>
																	<div class="p5" v-else>
																		<span></span>
																		<span>{{ itemf.price1[0] }}</span>
																	</div>
																</div>
															</div>
														</div>
													</template>
												</el-table-column>
												<!--结案反结案详情-关联合同附件-->
												<el-table-column v-else-if="itemc.prop == 'related_contracts_attachment'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.related_contracts_attachment.length > 0">
															<span v-for="(itemd, indexd) in scope.row.related_contracts_attachment">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.related_contracts_attachment.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<!--结案反结案详情-项目合同附件-->
												<el-table-column v-else-if="itemc.prop == 'solve_project_contract_attachment'"
													:width='itemc.width' :prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.solve_project_contract_attachment.length > 0">
															<span v-for="(itemd, indexd) in scope.row.solve_project_contract_attachment">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.solve_project_contract_attachment.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<!--开票信息或银行卡 fp_attachment-->
												<el-table-column v-else-if="itemc.prop == 'fp_attachment'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.fp_attachment.length > 0">
															<span v-for="(itemd, indexd) in scope.row.fp_attachment">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.fp_attachment.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<el-table-column v-else-if="itemc.prop == 'taxpayer_prove'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.taxpayer_prove.length > 0">
															<span v-for="(itemd, indexd) in scope.row.taxpayer_prove">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.taxpayer_prove.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<!--开票信息或银行卡 invoice_prove-->
												<el-table-column v-else-if="itemc.prop == 'invoice_prove'" :width='itemc.width'
													:prop="itemc.prop" :label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.invoice_prove.length > 0">
															<span v-for="(itemd, indexd) in scope.row.invoice_prove">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.invoice_prove.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<!--开票信息或银行卡 bank_prove-->
												<el-table-column v-else-if="itemc.prop == 'bank_prove'" :width='itemc.width' :prop="itemc.prop"
													:label="itemc.title">
													<template slot-scope="scope">
														<div v-if="scope.row.bank_prove.length > 0">
															<span v-for="(itemd, indexd) in scope.row.bank_prove">
																<el-link type="primary" :href="itemd" target="_blank"
																	rel="noopener noreferrer">附件{{ indexd + 1 }}</el-link>{{ indexd ==
																		scope.row.bank_prove.length - 1 ? '' : '、'}}
															</span>
														</div>
													</template>
												</el-table-column>
												<el-table-column v-else :min-width='itemc.width' :prop="itemc.prop" :label="itemc.title">
												</el-table-column>
											</template>
										</el-table>
										<el-pagination v-if="item.fun" background ref="pagination"
											@current-change="handleCurrentChange($event, item.fun, item.supplier_id)"
											:current-page="item.value.page | number" :page-size="item.value.pagesize | number"
											layout="total, prev, pager, next" :total="item.value.total | number">
										</el-pagination>
									</div>
								</div>
							</div>
						</div>
						<actionBar v-if="queryParams.type == 'approve' && infoData.title_info.title" :actioninfo="infoData"
							:loading.sync="loading"></actionBar>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
import layoutStep from '../approve/Step.vue'
import actionBar from '../approve/Actionbar.vue'
export default {
	props: ['info'],
	components: {
		layoutStep,
		actionBar
	},
	data () {
		return {
			activeName: 'first',
			size: 'mini',
			loading: false,
			infoData: {
				info: [],
				title_info: {},
				step_info: {}
			},
			queryParams: ''//跳转页面携带参数
		}
	},
	computed: {
	},
	mounted: function () {
		this.loading = true
		this.queryParams = this.$route.query;
		this.getDetail()
	},
	methods: {
		routerGo (url) {
			this.$router.push(url);
		},
		//获取详情
		getDetail () {
			let params = {}
			params.id = this.queryParams.id
			if (this.queryParams.set_id) {
				params.set_id = this.queryParams.set_id
			}
			if (this.queryParams.log_id) {
				params.log_id = this.queryParams.log_id
			}
			this.$api.get('/admin/customers/customer/getexamineinfoview', params).then(res => {
				if (res.code === 0) {
					this.infoData = res.data
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		goBack () {
			window.history.back()
		},
		handleCurrentChange (val, fun, id) {
			this.loading = true
			const index = this.infoData.info.findIndex(item => item.label === "资源列表");
			this.$api.get(fun, { page: val, supplier_id: id }).then(res => {
				if (res.code === 0) {
					this.infoData.info[index].value.data = res.data.data
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
	}
}
</script>
<style lang="scss" scoped>
.resourceCon {
	.addBox {
		margin-top: 60px;
	}

	.fyRadio {
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.fyRadioTitle {
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}

	.el-radio {
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}

.projectDetailInfo {
	position: relative;
	padding-left: 60px;
	height: 100%;
	margin-top: 20px;
	padding-bottom: 10px;

	.base-info-wrap {
		margin-bottom: 10px;

		.row {
			display: flex;
			font-size: 14px;
			align-items: center;
			flex-wrap: wrap;

			.column {
				width: 20%;
				padding-bottom: 14px;

				.column-label {
					margin-right: 14px;
					color: #a1a1a1;
				}

				.column-value {
					word-break: break-all;
					color: #333;

					&.red {
						color: #fb5555 !important;
						font-weight: 500;
					}
				}
			}
		}
	}

	.bg {
		position: absolute;
		top: 0;
		left: -24px;
		width: 36px;
		height: 100%;
		background: url(../../assets/images/titbg.png) no-repeat;
		background-size: 100% 100%;
		writing-mode: vertical-lr;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-left: 6px;
		font-size: 14px;
		text-indent: 10px;
		letter-spacing: 12px;
		color: #775905ec;
		border-radius: 8px;
		overflow: hidden;
	}

	.des {
		position: relative;
		color: #333;
		background: #f9fafd;
		border-radius: 8px;
		padding: 6px 10px;
		line-height: 30px;
		margin-top: -14px;
		font-size: 14px;

		div {
			white-space: pre-wrap;
		}

		span {
			font-weight: bolder;
			white-space: nowrap;
		}

		.desdemand {
			padding: 10px;
		}
	}
}

.projectDetailCenter {
	display: flex;
	justify-content: space-between;

	.left {
		width: calc(100% - 370px);
		height: 240px;
	}

	.right {
		width: 350px;
		height: 240px;
	}
}

.price-box-inner {
	max-height: auto !important;
}
</style>